<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-1786.251 -224)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1786.251 224)" />
			<path
				d="M20.75,2A18.75,18.75,0,1,0,39.5,20.75,18.757,18.757,0,0,0,20.75,2ZM17,30.125,7.625,20.75l2.644-2.644L17,24.819,31.231,10.588l2.644,2.662Z"
				transform="translate(1788.001 225.75)"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-check-circle',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
.a {
	fill: none;
}
</style>

<docs>
    IconCheckCircle

    ```js
    <b-icon-check-circle />
    ```
</docs>
